import { createI18n } from 'vue-i18n';
import { useI18n as useI18nExcalibur } from '@clicksign/excalibur/composables';

import ptBr from './ptBR';
import esMx from './esMx';

const DEFAULT_LOCALE = 'pt-BR';

const messages = {
  'pt-BR': ptBr,
  'es-MX': esMx,
};

const i18n = new createI18n({
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages,
  legacy: false,
  globalInjection: true,
  fallbackWarn: false,
  missingWarn: false,
});

export default i18n;

export function setLocale(locale) {
  if (!locale) return;
  i18n.global.locale.value = locale;

  const { setLocale: setExcaliburLocale } = useI18nExcalibur();
  setExcaliburLocale(locale);
}
